// extracted by mini-css-extract-plugin
export default {"wrapper":"FileUpload_wrapper__LuFbP","button":"FileUpload_button__TTr1o","input":"FileUpload_input__AfR4J","fileName":"FileUpload_fileName__KTRZM"};